import { BookDetailModel, BookModel } from "@/types/book";
import http from "../utils/http-client";
import { DefaultResponseModel } from "@/types/http";

/**
 * 获取用户已发行的书
 */
export const getUserPublishedList = () => {
  return http.get<Array<BookModel>>({
    url: "/api/book/user/books",
  });
};

/**
 * 获取用户草稿箱的书
 */
export const getUserDraftList = () => {
  return http.get<Array<BookModel>>({
    url: "/api/book/user/draft",
  });
};

/**
 * 获取用户草稿箱的书详情
 */
export const getBookDetailById = (id: number) => {
  return http.get<BookDetailModel>({
    url: "/api/book/detail/" + id,
  });
};

/**
 * 获取用户草稿箱的书
 */
export const getBookById = (id: number) => {
  return http.get<BookModel>({
    url: "/api/book/" + id,
  });
};

/**
 * 获取用户草稿箱的书
 */
export const deleteBook = (id: number) => {
  return http.delete<DefaultResponseModel>({
    url: "/api/book/delete/" + id,
    unprocessed: true,
    disableLoading: false,
  });
};

/**
 * 获取用户草稿箱的书
 */
export const publishBook = (id: number) => {
  return http.post<DefaultResponseModel>({
    url: "/api/book/publish",
    data: {
      id: id,
    },
    unprocessed: true,
  });
};

/**
 * 获取用户草稿箱的书
 */
export const draftBook = (id: number) => {
  return http.post<DefaultResponseModel>({
    url: "/api/book/draft",
    data: {
      id: id,
    },
    unprocessed: true,
  });
};

/**
 * 获取所有用户已发布的书
 */
export const getBookPublishedAll = () => {
  return http.get<Array<BookModel>>({
    url: "/api/book/all",
  });
};

/**
 * 书架内的所有数据
 */
export const getBookShelfAll = () => {
  return http.get<Array<BookModel>>({
    url: "/api/bookshelf/all",
  });
};

export const addToBookShelf = (bookId: number) => {
  return http.post<DefaultResponseModel>({
    url: "/api/bookshelf/add",
    data: {
      bookId,
    },
    unprocessed: true,
  });
};

export const removeInBookShelf = (bookId: number) => {
  return http.delete<DefaultResponseModel>({
    url: "/api/bookshelf/remove/" + bookId,
    unprocessed: true,
  });
};



/**
 * 点赞书 
 */
export const be_liked_book=(book_id:number)=>{
  return http.post<boolean>({
    url:'/api/book/like',
    data:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}

/**
 * 点赞书数量
 */
export const get_liked_count=(book_id:number)=>{
  return http.get<{
    count:number,
    fine:boolean
  }>({
    url:'/api/book/like/count',
    params:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}


/**
 * 分享书 
 */
export const share_book=(book_id:number)=>{
  return http.post<boolean>({
    url:'/api/book/share',
    data:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}

/**
 * 点赞书数量
 */
export const get_shared_count=(book_id:number)=>{
  return http.get<{
    count:number,
    fine:boolean
  }>({
    url:'/api/book/share/count',
    params:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}


/**
 * 收藏书 
 */
export const collect_book=(book_id:number)=>{
  return http.post<boolean>({
    url:'/api/book/collect',
    data:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}

/**
 * 书本收藏数量
 */
export const get_collect_count=(book_id:number)=>{
  return http.get<{
    count:number,
    fine:boolean
  }>({
    url:'/api/book/collect/count',
    params:{
      book_id,
    },
    // unprocessed: true,
    disableLoading:true
  })
}